export default "__VITE_ASSET__DqOap_QT__"